export default __webpack_public_path__ + "static/media/016-grilled meat.5394843d.svg";